import { render, staticRenderFns } from "./PosUpdaterV2.vue?vue&type=template&id=efcfd52a"
import script from "./PosUpdaterV2.vue?vue&type=script&lang=js"
export * from "./PosUpdaterV2.vue?vue&type=script&lang=js"
import style0 from "./PosUpdaterV2.vue?vue&type=style&index=0&id=efcfd52a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports